// 1. グループ情報
export type PickupGroupInfo = {
  sku: string;
  productCount: string;
  group: string;
  planName: string;
};

// 2. 商品情報（1商品分）
export type PickupProduct = {
  sku: string;
  productName: string;
  asin: string;
  fnsku: string;
  jan: string;
  condition: string;
  whoReady: string;
  whoPaste: string;
  packingType: string;
  count: string;
};

// 3. 輸送情報
export type PickupTransportInfo = {
  boxId: string;
  boxName: string;
  boxWeight: string;
  boxLength: string;
  boxWidth: string;
  boxHeight: string;
};

// 4. parsePickupCsvの戻り型
export type ParsedPickupCsv = {
  groupInfo: PickupGroupInfo;
  products: PickupProduct[];
  transportInfo: PickupTransportInfo;
};

const groupInfoMapping: Record<string, keyof PickupGroupInfo> = {
  SKU: "sku",
  商品数: "productCount",
  梱包グループ番号: "group",
  納品プラン名: "planName",
};

const productMapping: Record<string, keyof PickupProduct> = {
  SKU: "sku",
  商品名: "productName",
  ASIN: "asin",
  FNSKU: "fnsku",
  "UPC/EAN/ISBN/JAN/CODABAR": "jan",
  コンディション: "condition",
  "誰が商品の梱包準備をしますか？": "whoReady",
  "誰が商品ラベルの貼付を行いますか？": "whoPaste",
  梱包タイプ: "packingType",
  数量: "count",
};

const transportInfoMapping: Record<string, keyof PickupTransportInfo> = {
  輸送箱ID: "boxId",
  輸送箱名: "boxName",
  重量: "boxWeight",
  長さ: "boxLength",
  幅: "boxWidth",
  高さ: "boxHeight",
};

// UTF-8 として不正なバイト列なら Shift_JIS とみなしてデコードする
export const decodePickupCsv = (buffer: ArrayBuffer): string => {
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(buffer);
  } catch {
    return new TextDecoder("shift_jis").decode(buffer);
  }
};

export const parsePickupCsv = (csvText: string): ParsedPickupCsv => {
  const lines = csvText
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line !== "");

  const groupInfo = {} as PickupGroupInfo;
  const products: PickupProduct[] = [];
  const transportInfo = {} as PickupTransportInfo;

  let mode: "groupInfo" | "products" | "transportInfo" = "groupInfo";
  let productHeaders: string[] = [];

  for (let i = 0; i < lines.length; i++) {
    const cells = lines[i]
      .split(",")
      .map((cell) => cell.replace(/"/g, "").trim());

    if (
      cells.includes("SKU") &&
      cells.includes("商品名") &&
      cells.includes("ASIN")
    ) {
      mode = "products";
      productHeaders = cells;
      continue;
    }

    if (cells.includes("輸送箱ID")) {
      mode = "transportInfo";
      continue;
    }

    if (mode === "groupInfo") {
      const [japaneseKey, value] = cells;
      const englishKey = groupInfoMapping[japaneseKey];
      if (englishKey) {
        groupInfo[englishKey] = value;
      }
    } else if (mode === "products") {
      if (cells.length >= productHeaders.length) {
        const product = {} as PickupProduct;
        productHeaders.forEach((header, idx) => {
          const englishKey = productMapping[header];
          if (englishKey) {
            product[englishKey] = cells[idx] ?? "";
          }
        });
        products.push(product);
      }
    } else if (mode === "transportInfo") {
      console.log(cells[8]);
      console.log(cells[9]);
      const key = cells[8] ?? "";
      const value = cells[9] ?? "";
      const englishKey = transportInfoMapping[key];
      if (englishKey) {
        transportInfo[englishKey] = value ?? "";
      }
    }
  }

  // transportInfoの必須項目を補完
  const requiredTransportKeys: (keyof PickupTransportInfo)[] = [
    "boxId",
    "boxName",
    "boxWeight",
    "boxLength",
    "boxWidth",
    "boxHeight",
  ];
  requiredTransportKeys.forEach((key) => {
    if (!(key in transportInfo)) {
      transportInfo[key] = "";
    }
  });

  return { groupInfo, products, transportInfo };
};
